import { get } from './apiService';

const dashboardService = {
  getDashboardStats: async () => {
    try {
      return await get('Admin/dashboard', { withCredentials: true });
    } catch (err) {
      throw new Error(err.message || 'Failed to fetch dashboard stats');
    }
  },
};

export default dashboardService;


